import geometricProps from './geometricProps'

function EISDiagrams(data, bars, force, magnitudeX, magnitudeY) {
    //console.log(props.data)
    // var data = props.data
    // var bars = props.bars
    // var force = props.force
    var L
    var subdivision = 50
    var x = []
    var ymoment = []
    var yshear = []
    var ynormal = []

    data.forEach((item, i) => {
        var geometric = geometricProps(bars, i)
        L = geometric.L
        var dividedL = L/subdivision
        var xLength = 0

        x[i] = new Array(0)
        ymoment[i] = new Array(0)
        yshear[i] = new Array(0)
        ynormal[i] = new Array(0)

        //discretizando vetor força

        for(let j = 0; j < subdivision+1 ; j++){
            x[i].push(xLength)
            if(magnitudeX[i] !== 0 | magnitudeY[i] !== 0){
                var qy = magnitudeY[i]
                var qx = magnitudeX[i]
                var normal = qx*x[i][j] + data[i][0]
                var moment = (qy/2)*x[i][j]*x[i][j] + data[i][1]*x[i][j] + item[2]
                var shear = (qy)*x[i][j] + item[1]
            }
            else{
                normal = data[i][0]
                moment = data[i][1]*x[i][j] + item[2]
                shear =  data[i][1]
            }
            ymoment[i].push(moment.toFixed(2))
            yshear[i].push(shear.toFixed(2))
            ynormal[i].push(normal.toFixed(2))

            xLength += dividedL
        }
        //console.log(x)

    })

    //console.log(x)
    return {x, ymoment, yshear, ynormal}

}

export default EISDiagrams